module.exports = __webpack_public_path__ + "static/images/cluebg.ecce0a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/cluebg.jpg
// module id = 8LnQ
// module chunks = 1